"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventImpl = require("./Event-impl").implementation;

var MessageEventInit = require("../generated/MessageEventInit");

var MessageEventImpl =
/*#__PURE__*/
function (_EventImpl) {
  _inherits(MessageEventImpl, _EventImpl);

  function MessageEventImpl() {
    _classCallCheck(this, MessageEventImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MessageEventImpl).apply(this, arguments));
  }

  _createClass(MessageEventImpl, [{
    key: "initMessageEvent",
    value: function initMessageEvent(type, bubbles, cancelable, data, origin, lastEventId, source, ports) {
      if (this._dispatchFlag) {
        return;
      }

      this.initEvent(type, bubbles, cancelable);
      this.data = data;
      this.origin = origin;
      this.lastEventId = lastEventId;
      this.source = source;
      this.ports = ports;
    }
  }]);

  return MessageEventImpl;
}(EventImpl);

MessageEventImpl.defaultInit = MessageEventInit.convert(undefined);
module.exports = {
  implementation: MessageEventImpl
};